import { Suspense } from "react";
import { useGetWatchesQuery } from "@apac/price-watch";
import {
  WatchListPage,
  AirPriceWatchApp,
} from "@b2bportal/core-air-price-watch";
import { LazyLoading } from "@b2bportal/core-ui";

export const WatchesPage = () => {
  const { data: watches, isLoading, isError, refetch } = useGetWatchesQuery();
  return (
    <Suspense fallback={<LazyLoading />}>
      <AirPriceWatchApp>
        <WatchListPage
          watches={watches}
          isLoading={isLoading}
          hasError={isError}
          refetch={refetch}
        />
      </AirPriceWatchApp>
    </Suspense>
  );
};
